// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import { dispatch } from '../index';
import {API} from "aws-amplify";

// ----------------------------------------------------------------------

const apiName = process.env.REACT_APP_ENDPOINT_NAME
const path_get_kanban_items = process.env.REACT_APP_KANBAN_GET_ITEMS
const path_get_kanban_columns = process.env.REACT_APP_KANBAN_GET_COLUMNS
const path_get_kanban_columns_order = process.env.REACT_APP_KANBAN_GET_COLUMNS_ORDER
const path_get_kanban_comments = process.env.REACT_APP_KANBAN_GET_COMMENTS
const path_get_kanban_profiles = process.env.REACT_APP_KANBAN_GET_PROFILES
const path_get_kanban_userstory = process.env.REACT_APP_KANBAN_GET_USERSTORY
const path_get_kanban_userstory_order = process.env.REACT_APP_KANBAN_GET_USERSTORY_ORDER
const path_post_kanban_select_item = process.env.REACT_APP_KANBAN_POST_SELECT_ITEM
const path_post_kanban_delete_item = process.env.REACT_APP_KANBAN_POST_DELETE_ITEM
const path_post_kanban_edit_item = process.env.REACT_APP_KANBAN_POST_EDIT_ITEM
const path_post_kanban_add_column = process.env.REACT_APP_KANBAN_POST_ADD_COLUMN
const path_post_kanban_add_story = process.env.REACT_APP_KANBAN_POST_ADD_STORY
const path_post_kanban_add_item = process.env.REACT_APP_KANBAN_POST_ADD_ITEM
const path_post_kanban_add_item_comment = process.env.REACT_APP_KANBAN_POST_ADD_ITEM_COMMENT
const path_post_kanban_delete_column = process.env.REACT_APP_KANBAN_POST_DELETE_COLUMN
const path_post_kanban_edit_column = process.env.REACT_APP_KANBAN_POST_EDIT_COLUMN
const path_post_kanban_update_column_order = process.env.REACT_APP_KANBAN_POST_UPDATE_COLUMN_ORDER
const path_post_kanban_update_column_item_order = process.env.REACT_APP_KANBAN_POST_UPDATE_COLUMN_ITEM_ORDER
const path_post_kanban_edit_story = process.env.REACT_APP_KANBAN_POST_EDIT_STORY
const path_post_kanban_update_story_order = process.env.REACT_APP_KANBAN_POST_UPDATE_STORY_ORDER
const path_post_kanban_update_story_item_order = process.env.REACT_APP_KANBAN_POST_UPDATE_STORY_ITEM_ORDER
const path_post_kanban_add_story_comment = process.env.REACT_APP_KANBAN_POST_ADD_STORY_COMMENT
const path_post_kanban_delete_story = process.env.REACT_APP_KANBAN_POST_DELETE_STORY

const initialState = {
  error: null,
  columns: [],
  columnsOrder: [],
  comments: [],
  items: [],
  profiles: [],
  selectedItem: false,
  userStory: [],
  userStoryOrder: [],
  xero_tenant: {},
  selected_tenant: null
};

const slice = createSlice({
  name: 'kanban',
  initialState,
  reducers: {
    handlerSetXeroTenant(state, action){
      state.xero_tenant=action.payload.xero_tenant;
      return state
    },

    handlerSetTenantSelect(state, action){
      state.selected_tenant=action.payload.selected_tenant;
      return state
    },

    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    // ADD COLUMN
    addColumnSuccess(state, action) {
      console.log(action)
      state.columns = action.payload.columns;
      state.columnsOrder = action.payload.columnsOrder;
    },

    // EDIT COLUMN
    editColumnSuccess(state, action) {
      state.columns = action.payload.columns;
    },

    // UPDATE COLUMN ORDER
    updateColumnOrderSuccess(state, action) {
      state.columnsOrder = action.payload.columnsOrder;
    },

    // DELETE COLUMN
    deleteColumnSuccess(state, action) {
      state.columns = action.payload.columns;
      state.columnsOrder = action.payload.columnsOrder;
    },

    // ADD ITEM
    addItemSuccess(state, action) {
      state.items = action.payload.items;
      state.columns = action.payload.columns;
      state.userStory = action.payload.userStory;
    },

    // EDIT ITEM
    editItemSuccess(state, action) {
      state.items = action.payload.items;
      state.columns = action.payload.columns;
      state.userStory = action.payload.userStory;
    },

    // UPDATE COLUMN ITEM ORDER
    updateColumnItemOrderSuccess(state, action) {
      state.columns = action.payload.columns;
    },

    // SELECT ITEM
    selectItemSuccess(state, action) {
      state.selectedItem = JSON.parse(action.payload).selectedItem;
    },

    // ADD ITEM COMMENT
    addItemCommentSuccess(state, action) {
      state.items = action.payload.items;
      state.comments = action.payload.comments;
    },

    // DELETE ITEM
    deleteItemSuccess(state, action) {
      console.log(action);
      state.items = action.payload.items;
      state.columns = action.payload.columns;
      state.userStory = action.payload.userStory;
    },

    // ADD STORY
    addStorySuccess(state, action) {
      state.userStory = action.payload.userStory;
      state.userStoryOrder = action.payload.userStoryOrder;
    },

    // EDIT STORY
    editStorySuccess(state, action) {
      state.userStory = action.payload.userStory;
    },

    // UPDATE STORY ORDER
    updateStoryOrderSuccess(state, action) {
      state.userStoryOrder = action.payload.userStoryOrder;
    },

    // UPDATE STORY ITEM ORDER
    updateStoryItemOrderSuccess(state, action) {
      state.userStory = action.payload.userStory;
    },

    // ADD STORY COMMENT
    addStoryCommentSuccess(state, action) {
      state.userStory = action.payload.userStory;
      state.comments = action.payload.comments;
    },

    // DELETE STORY
    deleteStorySuccess(state, action) {
      state.userStory = action.payload.userStory;
      state.userStoryOrder = action.payload.userStoryOrder;
    },

    // GET COLUMNS
    getColumnsSuccess(state, action) {
      state.columns = action.payload;
      console.log(action.payload)
      return state
    },

    // GET COLUMNS ORDER
    getColumnsOrderSuccess(state, action) {
      state.columnsOrder = action.payload;
      return state
    },

    // GET COMMENTS
    getCommentsSuccess(state, action) {
      state.comments = action.payload;
      return state
    },

    // GET PROFILES
    getProfilesSuccess(state, action) {
      state.profiles = action.payload;
      return state
    },

    // GET ITEMS
    getItemsSuccess(state, action) {
      state.items = action.payload;
      return state
    },

    // GET USER STORY
    getUserStorySuccess(state, action) {
      state.userStory = action.payload;
      return state
    },

    // GET USER STORY ORDER
    getUserStoryOrderSuccess(state, action) {
      state.userStoryOrder = action.payload;
      return state
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getColumns(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "selected_tenant": selected_tenant
      }
    }
    API.get(apiName,path_get_kanban_columns,myInit)
        .then(response => {
          console.log(response);
          dispatch(slice.actions.getColumnsSuccess(response.data.columns))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/columns');
    //   dispatch(slice.actions.getColumnsSuccess(response.data.columns));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function getColumnsOrder(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {"selected_tenant": selected_tenant}
    }
    API.get(apiName,path_get_kanban_columns_order,myInit)
        .then(response => {
          console.log(response)
          dispatch(slice.actions.getColumnsOrderSuccess(response.data.columnsOrder))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/columns-order');
    //   dispatch(slice.actions.getColumnsOrderSuccess(response.data.columnsOrder));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function getComments(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {"selected_tenant": selected_tenant}
    }
    API.get(apiName,path_get_kanban_comments,myInit)
        .then(response => {
          dispatch(slice.actions.getCommentsSuccess(response.data.comments))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/comments');
    //   dispatch(slice.actions.getCommentsSuccess(response.data.comments));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function getProfiles(xero_tenant, selected_tenant) {
  return async () => {
    console.log(xero_tenant);
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "xero_tenant": JSON.stringify(xero_tenant),
        "selected_tenant": selected_tenant
      }
    }
    API.get(apiName,path_get_kanban_profiles,myInit)
        .then(response => {
          dispatch(slice.actions.getProfilesSuccess(response.data.profiles))
        }).catch(error => {
          console.log(error);
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/profiles');
    //   dispatch(slice.actions.getProfilesSuccess(response.data.profiles));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function getItems(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {"selected_tenant": selected_tenant}
    }
    API.get(apiName,path_get_kanban_items,myInit)
        .then(response => {
          dispatch(slice.actions.getItemsSuccess(response.data.items))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
  };
}

export function getUserStory(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {"selected_tenant": selected_tenant}
    }
    API.get(apiName,path_get_kanban_userstory,myInit)
        .then(response => {
          dispatch(slice.actions.getUserStorySuccess(response.data.userStory))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/userstory');
    //   dispatch(slice.actions.getUserStorySuccess(response.data.userStory));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function getUserStoryOrder(selected_tenant) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "selected_tenant": selected_tenant
      }
    }
    API.get(apiName,path_get_kanban_userstory_order,myInit)
        .then(response => {
          dispatch(slice.actions.getUserStoryOrderSuccess(response.data.userStoryOrder))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.get('/api/kanban/userstory-order');
    //   dispatch(slice.actions.getUserStoryOrderSuccess(response.data.userStoryOrder));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function addColumn(column, columns, columnsOrder, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {column, columns, columnsOrder, selected_tenant}
      }
      API.post(apiName,path_post_kanban_add_column,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.addColumnSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
  };
}

export function editColumn(column, columns, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {column, columns, selected_tenant}
      }
      API.post(apiName,path_post_kanban_edit_column,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.editColumnSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/edit-column', { column, columns });
    //   dispatch(slice.actions.editColumnSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function updateColumnOrder(columnsOrder, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {columnsOrder, selected_tenant}
      }
      API.post(apiName,path_post_kanban_update_column_order,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.updateColumnOrderSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/update-column-order', { columnsOrder });
    //   dispatch(slice.actions.updateColumnOrderSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function deleteColumn(columnId, columnsOrder, columns, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {columnId, columnsOrder, columns, selected_tenant}
      }
      API.post(apiName,path_post_kanban_delete_column,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.deleteColumnSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/delete-column', { columnId, columnsOrder, columns });
    //   dispatch(slice.actions.deleteColumnSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function addItem(columnId, columns, item, items, storyId, userStory, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {columnId, columns, item, items, storyId, userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_add_item,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.addItemSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/add-item', { columnId, columns, item, items, storyId, userStory });
    //   dispatch(slice.actions.addItemSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function editItem(columnId, columns, item, items, storyId, userStory, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {columnId, columns, item, items, storyId, userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_edit_item,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.editItemSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/edit-item', { items, item, userStory, storyId, columns, columnId });
    //   dispatch(slice.actions.editItemSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function updateColumnItemOrder(columns, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {columns, selected_tenant}
      }
      API.post(apiName,path_post_kanban_update_column_item_order,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.updateColumnItemOrderSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/update-item-order', { columns });
    //   dispatch(slice.actions.updateColumnItemOrderSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function selectItem(selectedItem) {
  return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {selectedItem}
    }
    API.post(apiName,path_post_kanban_select_item,myInit)
        .then(response => {
          console.log(response)
          dispatch(slice.actions.selectItemSuccess(response.data))
        }).catch(error => {
          dispatch(slice.actions.hasError(error))
    })
    // try {
    //   const response = await axios.post('/api/kanban/select-item', { selectedItem });
    //   dispatch(slice.actions.selectItemSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function addItemComment(itemId, comment, items, comments, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {itemId, comment, items, comments, selected_tenant}
      }
      API.post(apiName,path_post_kanban_add_item_comment,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.addItemCommentSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })

    // try {
    //   const response = await axios.post('/api/kanban/add-item-comment', { items, itemId, comment, comments });
    //   dispatch(slice.actions.addItemCommentSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function deleteItem(itemId, items, columns, userStory, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {itemId, items, columns, userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_delete_item,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.deleteItemSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/delete-item', { columns, itemId, userStory, items });
    //   dispatch(slice.actions.deleteItemSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function addStory(story, userStory, userStoryOrder, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {story, userStory, userStoryOrder, selected_tenant}
      }
      API.post(apiName,path_post_kanban_add_story,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.addStorySuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
  };
}

export function editStory(story, userStory, selected_tenant) {
  return async () => {

    var myInit = {};
      myInit = {
        headers: {},
        body: {story, userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_edit_story,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.editStorySuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/edit-story', { userStory, story });
    //   dispatch(slice.actions.editStorySuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function updateStoryOrder(userStoryOrder, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {userStoryOrder, selected_tenant}
      }
      API.post(apiName,path_post_kanban_update_story_order,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.updateStoryOrderSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/update-story-order', { userStoryOrder });
    //   dispatch(slice.actions.updateStoryOrderSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function updateStoryItemOrder(userStory, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_update_story_item_order,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.updateStoryItemOrderSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/update-storyitem-order', { userStory });
    //   dispatch(slice.actions.updateStoryItemOrderSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function addStoryComment(storyId, comment, comments, userStory, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {storyId, comment, comments, userStory, selected_tenant}
      }
      API.post(apiName,path_post_kanban_add_story_comment,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.addStoryCommentSuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/add-story-comment', { userStory, storyId, comment, comments });
    //   dispatch(slice.actions.addStoryCommentSuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export function deleteStory(storyId, userStory, userStoryOrder, selected_tenant) {
  return async () => {
    var myInit = {};
      myInit = {
        headers: {},
        body: {storyId, userStory, userStoryOrder, selected_tenant}
      }
      API.post(apiName,path_post_kanban_delete_story,myInit)
          .then(response => {
            console.log(response)
            dispatch(slice.actions.deleteStorySuccess(response.data))
          }).catch(error => {
            dispatch(slice.actions.hasError(error))
      })
    // try {
    //   const response = await axios.post('/api/kanban/delete-story', { userStory, storyId, userStoryOrder });
    //   dispatch(slice.actions.deleteStorySuccess(response.data));
    // } catch (error) {
    //   dispatch(slice.actions.hasError(error));
    // }
  };
}

export const {handlerSetXeroTenant, handlerSetTenantSelect} = slice.actions;
